var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ViewType } from "../../models/view-type";
import { Base } from "../base";
import { Icon } from "./icon";
import { Input } from "./input";
var InputArea = /** @class */ (function (_super) {
    __extends(InputArea, _super);
    function InputArea(configuration, viewType, sendMessageAction) {
        var _this = _super.call(this) || this;
        _this.focus = function () {
            _this._input.focus();
        };
        _this.enable = function () {
            _this.self.removeAttribute('disabled');
            _this._input.enable();
            _this._button.enable();
            _this.self.style.opacity = '1';
            _this.self.style.cursor = 'pointer';
        };
        _this.disable = function (preserveInputFocus) {
            if (preserveInputFocus === void 0) { preserveInputFocus = false; }
            _this.self.setAttribute('disabled', 'true');
            if (!preserveInputFocus) {
                _this._input.disable();
            }
            _this._button.disable();
            _this.self.style.opacity = '0.75';
            _this.self.style.cursor = 'wait';
        };
        _this.setSmallSizeWindow = function () {
            _this.self.style.width = '350px';
            _this._input.setSmallSizeWindow();
        };
        _this.setFullSizeWindow = function () {
            _this.self.style.width = '100%';
            _this._input.setFullSizeWindow();
        };
        var inputArea = document.createElement('div');
        inputArea.id = 'js_aigo_bot_input_area';
        inputArea.placeholder = configuration.questionInputText;
        inputArea.style.marginTop = '3px';
        inputArea.style.borderRadius = '5px';
        inputArea.style.color = configuration.questionInputFontColor;
        inputArea.style.backgroundColor = configuration.questionInputBackgroundColor;
        inputArea.style.display = 'flex';
        inputArea.style.alignItems = 'center';
        // Send the current input when the 'enter' key is clicked.
        inputArea.addEventListener('keypress', function (event) {
            if (event.key === 'Enter' && event.target instanceof HTMLInputElement) {
                if (event.target.value && event.target.value.length > 0) {
                    var trimmedValue = event.target.value.trim();
                    if (trimmedValue.length > 0) {
                        _this._button.self.click();
                    }
                }
            }
        });
        _this._input = new Input(configuration, viewType);
        _this._button = new Icon('js_aigo_bot_send_message_icon', configuration.sendButtonIcon, '24px', '24px', configuration.sendButtonColor, '5px', sendMessageAction, true, 'Send message');
        _this._button.self.style.flexShrink = '0';
        inputArea.appendChild(_this._input.self);
        inputArea.appendChild(_this._button.self);
        _this.self = inputArea;
        if (viewType === ViewType.DesktopSmall) {
            _this.setSmallSizeWindow();
        }
        else {
            _this.setFullSizeWindow();
        }
        if (viewType === ViewType.MobileSmall || viewType === ViewType.MobileLarge) {
            inputArea.style.marginTop = '-3px';
            _this._button.self.addEventListener('pointerdown', function (event) {
                event.preventDefault();
            });
        }
        return _this;
    }
    InputArea.prototype.getValue = function () {
        return this._input.getValue();
    };
    InputArea.prototype.clearValue = function () {
        this._input.clearValue();
    };
    return InputArea;
}(Base));
export { InputArea };
